import React from "react";

// Reno-web uses inline styles (not Tailwind), so the pill colors are
// expressed as hex equivalents of portal's `bg-green-100/700` and
// `bg-purple-100/700` Tailwind classes.
const TONES = {
  green: {
    background: "#dcfce7",
    color: "#15803d",
    borderColor: "#bbf7d0",
  },
  purple: {
    background: "#f3e8ff",
    color: "#7e22ce",
    borderColor: "#e9d5ff",
  },
};

const Pill = ({ label, tone }) => {
  const c = TONES[tone] || TONES.green;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "2px 8px",
        fontSize: 10,
        fontWeight: 500,
        borderRadius: 999,
        border: `1px solid ${c.borderColor}`,
        background: c.background,
        color: c.color,
        lineHeight: 1.4,
      }}
    >
      {label}
    </span>
  );
};

/**
 * Renders Supply/Apply as colored status pills.
 *  - "Supply"           → one green pill
 *  - "Apply"            → one purple pill
 *  - "Supply and Apply" → two pills (green Supply + purple Apply)
 * Returns null when the value is missing / unrecognized.
 * Comparison is case-insensitive — existing data may be lowercase.
 */
const SupplyApplyPills = ({ supplyType, style }) => {
  if (!supplyType) return null;
  const lower = String(supplyType).toLowerCase().trim();

  if (lower === "supply and apply") {
    return (
      <span
        style={{
          display: "inline-flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 4,
          ...(style || {}),
        }}
      >
        <Pill label="Supply" tone="green" />
        <Pill label="Apply" tone="purple" />
      </span>
    );
  }
  if (lower === "supply") {
    return (
      <span style={{ display: "inline-flex", alignItems: "center", ...(style || {}) }}>
        <Pill label="Supply" tone="green" />
      </span>
    );
  }
  if (lower === "apply") {
    return (
      <span style={{ display: "inline-flex", alignItems: "center", ...(style || {}) }}>
        <Pill label="Apply" tone="purple" />
      </span>
    );
  }
  return null;
};

export default SupplyApplyPills;
